module.exports = __webpack_public_path__ + "static/img/11.a875529.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/11.png
// module id = m+hG
// module chunks = 0